module.exports = __webpack_public_path__ + "static/media/Sketch-up.06ed2626.png";